@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';

.advanced-options-step {
  padding: @space-24 @space-0;
  max-width: 835px;
  margin: @space-0 auto;

  .congratulations-banner {
    background-color: var(--green-00331C);
    border-radius: 8px;
    padding: @space-32 @space-24;
    text-align: center;
    margin-bottom: @space-32;
  }

  .check-icon {
    color: var(--green-22EE88);
    width: 36px;
    height: 36px;
    font-size: 36px;
    margin: @space-0 auto @space-16;
  }

  .congratulations-title {
    color: var(--white);
    font-weight: 700;
    margin: @space-0;
  }

  .congratulations-subtitle {
    margin: @space-8 @space-0 @space-0 @space-0;
    color: rgba(255, 255, 255, 0.7);
  }

  .header-section {
    text-align: left;

    .header {
      margin: @space-0;
      font-weight: 700;
    }
  }

  .todo-cards-section {
    margin: @space-24 @space-0 @space-48 @space-0;
    overflow: visible;
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: @space-24;
    overflow: visible;
  }
}

@media @mobile, @ultramobile {
  .advanced-options-step {
    padding: @space-16 @space-0;

    .cards-grid {
      grid-template-columns: 1fr;
    }
  }
}
